import { useState } from "react";
import { BRAND } from "@core/brand/brand-config";
import axios from "axios";
import IntelLayout from "../layout";
import { toast } from "react-toastify";
import { globalGetApiUrl } from "../../../utils/globalBaseUrl";
import { trademoTrackingEvents } from "../../../core/global/trademo-tracking";
import { generateTrackingObject } from "../../../core/global/global-country-functions";
import { getIntelUrl } from "../../../utils/intelUrl";
import trackingEventDictionary from "../../../core/dictionary/tracking-event";

export default function FreeTrialLandingPage() {
  const [showNotification, setShowNotification] = useState(false);
  let user_active_plan = !!JSON.parse(localStorage.getItem("userCurrentPlan")) && !!JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan ? JSON.parse(localStorage.getItem("userCurrentPlan")).user_active_plan : "trademo_intel_us_enterprise";

  const callingTrackingEvents = (eventName, path) => {
    trademoTrackingEvents(eventName, generateTrackingObject("product", !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", user_active_plan));
    if (!!path && path !== "") {
      window.location.href = getIntelUrl() + path;
    }
  };

  const assignProduct = () => {
    const requestObj = {
      productName: "intel",
      is_free_trial: true,
      dataSource: "product",
      noOfDays: 14,
    };
    callingTrackingEvents(trackingEventDictionary.allAppsFreeIntel);
    axios
      .post(globalGetApiUrl("auth/extendAccount"), requestObj)
      .then((res) => {
        if (res) {
          toast.success("Products Have Been Assigned, you need to logout before you can use the assigned products.");
          setTimeout(() => {
            window.location.reload(false);
            window.location.href = "search-shipments";
          }, 2000);
        }
      })
      .catch((err) => toast.error(err));
  };
  return (
    <>
      <IntelLayout
        pageTitle="Free Trial | Trademo Intel"
        setNotification={(val) => {
          setShowNotification(val);
        }}
        showNotification={showNotification}>
        <section className="d-flex flex-column align-items-center free-trial-landing-page">
          <h3 className="mb-3">{BRAND.name}</h3>
          <h1 className="mb-5">
            #1 Source for Global Supply Chain <br></br> Intelligence
          </h1>
          <p className="mb-4">
            {BRAND.name}'s import-export transactional data intelligence help businesses maximize revenue, diversify supply chains,<br></br>build operational resilience, and gain a competitive edge.
          </p>
          <button className="mt-2 btn btn-primary trademo-new-btn px-3" onClick={() => assignProduct()}>
            Start Your 14-days Free Trial
          </button>
        </section>
      </IntelLayout>
    </>
  );
}
